import type { PartialTheme } from '@nivo/theming'
import type { CSSProperties } from 'react'

type NivoTooltipWrapperStyle = Pick<CSSProperties, 'width' | 'maxWidth'>
type NivoTooltipWrapperTheme = Omit<PartialTheme, 'tooltip'> & {
    tooltip?: PartialTheme['tooltip'] & NivoTooltipWrapperStyle
}

const tooltipWrapperStyle = {
    width: 'max-content',
    maxWidth: 'none',
} satisfies NivoTooltipWrapperStyle

export const nivoTooltipWrapperTheme: NivoTooltipWrapperTheme = {
    tooltip: tooltipWrapperStyle,
}

export function withNivoTooltipWrapperTheme(theme: PartialTheme): NivoTooltipWrapperTheme {
    return {
        ...theme,
        tooltip: {
            ...tooltipWrapperStyle,
            ...theme.tooltip,
        },
    }
}
